import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles"

import { TopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

import { VENDOR_ROUTES } from "@routes/vendor"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { VENDORS_LIST_CONTROLS_VIEW } from "@constants/storage"

import VendorTableView from "./views/VendorTableView/VendorTableView"

export default function VendorList() {
    const [createRoute] = useSlugExtractor([VENDOR_ROUTES.CREATE])

    return (
        <AppFrame.Root pageId="VendorList">
            <ViewTypesProvider viewTypeKey={VENDORS_LIST_CONTROLS_VIEW} defaultViewType="table">
                {() => (
                    <>
                        <TopBar.Root>
                            <TopBar.Header>
                                <TopBar.TopBarHeaderStart>
                                    <TopBar.PageTitle
                                        label={objectMap.vendor.labelPlural}
                                        icon={objectMap.vendor.iconActive}
                                    />
                                </TopBar.TopBarHeaderStart>
                                <TopBar.TopBarHeaderEnd>
                                    <TopBar.PagePresence />
                                    <AccessCheck
                                        permissions={{
                                            vendors_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <AccessCheck
                                            permissions={{
                                                vendors_view_permission: PERMISSION_LEVEL.FULL,
                                            }}
                                        >
                                            <TopBar.SearchButton scope="Vendors" />
                                        </AccessCheck>
                                    </AccessCheck>
                                    <TopBar.ViewSelector viewTypes={["table"]} />
                                    <AccessCheck
                                        permissions={{
                                            vendors_create_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <TopBar.CTAButton destination={createRoute} />
                                    </AccessCheck>
                                </TopBar.TopBarHeaderEnd>
                            </TopBar.Header>
                        </TopBar.Root>
                        <VendorTableView />
                    </>
                )}
            </ViewTypesProvider>
        </AppFrame.Root>
    )
}
